module.exports = __webpack_public_path__ + "img/aside_top.1fd41393.png";